import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbIconLibraries, NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ViewContainersService, UpdateComponentStoreService, UbsComponentStoreService, BaseComponentConfig, ActionState, Relation, SelectedValue, CustomContainerItem, ComponentConfig, CUSTOM_ICONS, ComponentTask } from '@urbannex/view-containers';
import { map, Subject } from 'rxjs';
import { options } from '../configoptions';
import { FacilityOverviewComponent } from './facility-overview/facility-overview.component';
import { RemoteFormData } from '@urbannex/ofbiz-forms';

@Component({
  selector: 'ubs-facility',
  templateUrl: './facility.component.html',
  styleUrls: ['./facility.component.scss']
})
export class FacilityComponent extends BaseComponentConfig implements OnInit,OnDestroy {
  facilityId:string;

  readonly routeParams$ = this.route.paramMap.pipe(map(params => params));

  private destroy$ = new Subject<void>();

  defaultAction = ActionState.LIST;

  /**
   * Type from menuItem data object used to resolve the master-detail/relation specified in the context menu
   */
  selectedValueType:string;
  
  @Output() contextMenuItems = new EventEmitter<NbMenuItem[]>()   
  
  constructor(viewContainerService:ViewContainersService,
      menuService:NbMenuService,
      route:ActivatedRoute,
      router:Router,
      updateComponentStoreService:UpdateComponentStoreService,
      configurationService:ConfigurationService,
      private iconLibraries: NbIconLibraries,
      private componentStore:UbsComponentStoreService) { 
      super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
      this.iconLibraries.registerSvgPack('custom-icons', CUSTOM_ICONS);
      this.routeParams$.subscribe(params => {
        if(params.get("facilityId")){
          this.facilityId = params.get("facilityId")
        }
        if(params.get("event")){
          this.action = this.setActionStateFromParam(params.get("event"));
          console.log(params.get("event"))
        }else{
          this.route.data.subscribe(data => {
            if(data.event){
              console.log("getting evet from route data",data.event);
              this.action = this.setActionStateFromParam(data.event);
              this.routerData = data;
            }
          });
        }
      });
      /**
       * Handle menu clicks
       */
      this.menuService.onItemClick().subscribe((event) => {
        if(event.tag != 'contextMenu'){
          if(event.item.data){}
        }else if(event.tag == 'contextMenu'){
          if(event.item.data){
            let data = event.item.data;
            this.action = data.event;
            this.selectedValueType = data.type?data.type:this.setSelectedValueType(this.action);
          }
        }
      });
      this.route.paramMap.subscribe((params) => {
        if(params.get("facilityId")){
          this.facilityId = params.get("facilityId");
          if(this.facilityId != undefined){
            this.route.data.subscribe(data => {
              console.log(data);
              if(data.event){
                this.action = data.event;
                this.routerData = data;
              }
            })
            if(params.get("event")){
            }
            //this.createMenuItems(this.orderId);
            options.defaultAction =  ActionState.CUSTOM;
            //this.setSelectedValue(this.orderId);
            //this.createMenuItems(this.orderId);
          }
          //this.hasValue = true;
        }
      })
  }
  
  ngOnInit(): void {
    if(this.facilityId != undefined){
      if(this.action != null && this.action != undefined){
        this.selectedValueType = this.setSelectedValueType(this.action);
        if(this.action == ActionState.MASTERDETAIL || this.action == ActionState.RELATE){
          if(this.action == ActionState.MASTERDETAIL){
            options.selectedMasterDetails = this.setSelectedRelation(this.action,this.selectedValueType);
          }
          if(this.action == ActionState.RELATE){
            options.selectedRelation = this.setSelectedRelation(this.action,this.selectedValueType);
          }
          this.setListOption(this.action);
        }else if(this.action == ActionState.TASKSACTRSLT) {
          options.selectedTask = this.setSelectedTask (this.selectedValueType);
        }
      }
      this.setSelectedValue(this.facilityId);
      this.createMenuItems(this.facilityId);      
    }else{
      if(this.action == ActionState.LIST){
        console.log(options);
        options.listForm = options.listForm;
      }
    }
    options.breadCrumbData = {
      displayPrefix:"Product Feature Categories",
      addFormText:"Create Feature Category",
      editFormText:"Update Feature Category"
    }
    options.defaultAction =  this.action?this.action:this.defaultAction;
    this.componentConfig = new ComponentConfig(options);
  }

  setSelectedValueType(action:ActionState):string{
    let url:string;
    let selectedValueType;
    switch (action) {
      case ActionState.CUSTOM:
        if (this.router.url.includes('facility-overview')) {
            selectedValueType = "FacilityOverView";
            options.customContainerItems = [new CustomContainerItem("FacilityOverView", FacilityOverviewComponent, {facilityId:this.facilityId})]
          /* } else if (this.url.includes('customer-info/contacts')) {
            selectedValueType = "OrderCustomer";
            options.customContainerItems = [new CustomContainerItem("OrderCustomer", OrderCustomerComponent, {orderId:this.orderId})] 
          } else if (this.url.includes('customer-info/history')) {
            selectedValueType = "OrderHistory";
            options.customContainerItems = [new CustomContainerItem("OrderHistory", OrderHistoryComponent, {orderId:"",partyId:this.partyId,facilityId:"WebStoreWarehouse"})]*/
          }
        break;
      case ActionState.MASTERDETAIL:
          if(this.router.url.includes('facility-locations')){
            selectedValueType = "Facility Locations";
          }
        break;
      case ActionState.RELATE:
        if(this.router.url.includes('inventory-products')){
          selectedValueType = "Inventory Products"
        }else if(this.router.url.includes('inventory-items')){
          selectedValueType = "Inventory Items"
        }
        break;
      case ActionState.TASKSACTRSLT:
        if(this.router.url.includes('receive-inventory-order')){
          selectedValueType = "Receive Inventory By Purchase Order"
        }else if(this.router.url.includes('receive-inventory-product')){
          selectedValueType = "Receive Inventory By Product"
        }
        break
      default:
        break;
    }

    return selectedValueType;
  }

  setSelectedRelation(action,selectedValueType):Relation{
    let selectedRelation;
    switch (action) {
      case ActionState.MASTERDETAIL:
        let masterDetails:any[] = options.masterDetails;
        masterDetails.forEach((masterDetail:Relation,i) => {
          console.log(masterDetail.title,selectedValueType);
          if(masterDetail.title == selectedValueType){
            selectedRelation = masterDetail;
            selectedRelation.listForm.findParameters = [];
            selectedRelation.listForm.findParameters.push({"facilityId":this.facilityId});
            if(selectedValueType == "Facility Locations"){
              selectedRelation.listForm.findParameters.push({"facilityId":this.facilityId});
              //selectedRelation.listForm.findParameters.push({facilityId:"WebStoreWarehouse"});
              //selectedRelation.listDetail.findParameters = [{orderId:this.orderId},{facilityId:"WebStoreWarehouse"}];
            }
            if(selectedValueType == "Ship Group Items"){
              selectedRelation.listDetail.findParameters = [{facilityId:this.facilityId}];
            }
            if(selectedRelation.isDymanic){
              selectedRelation.dynamicAddForms.forEach(form => {
                form.breadCrumbData.data.parameters.facilityId = this.facilityId;
              })
            }
          }
          console.log(selectedRelation);
      })
        break;
      case ActionState.RELATE:
        let relations:any[] = options.relations;
        relations.forEach((relation:Relation,i) => {
          console.log(relation.title,selectedValueType);
          if(relation.title == selectedValueType){
            selectedRelation = relation;
            selectedRelation.listForm.findParameters = [];
            selectedRelation.listForm.findParameters.push({"facilityId":this.facilityId});
          }
          console.log(selectedRelation);
        })
        break;
    }
    return selectedRelation;
  }

  setSelectedTask(selectedValueType){
    let selectedTask;
    let tasks:any[] = options.tasks;
      tasks.forEach((task:ComponentTask,i) => {
        console.log(task.title,selectedValueType);
        if(task.title == selectedValueType){
          selectedTask = task;
        }
      })
    return selectedTask
  }

  setSelectedValue(facilityId:string){
      console.log(this.action);
      let selectedValue:SelectedValue = {
        event:this.action?this.action:ActionState.CUSTOM,
        type:this.selectedValueType?this.selectedValueType:"FacilityOverView",
        label:"Facility",
        data:{
          formData: {
            formName: 'EditProductRest',
            formLocation: 'component://kwikstore/widget/FacilityForms.xml',
          },
          parameters:{"facilityId":facilityId}
        }
  
      }
      setTimeout(() =>{
        console.log(this.action)
        options.defaultAction = this.action?this.action:ActionState.CUSTOM;
  
        //this.componentStore.updateComponentConfig(this.componentConfig);
        //console.log(this.componentConfig);
        this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
        //this.hasValue=true;
      },500)
      
    }

  setListOption(action:ActionState){
    switch (action) {
      case ActionState.MASTERDETAIL:
        options.listForm.findParameters = [];
        //options.listForm = this.selectedMasterDetail?.listForm?this.selectedMasterDetail.listForm:options.selectedMasterDetails.listForm;//options.masterDetails[0].listForm;
        //options.listForm.findParameters.push({"orderId":this.orderId});
        break;
      case ActionState.RELATE:
        //options.listForm = options.relations[0].listForm;
        break;
      default:
        options.listForm = options.listForm;
        break;
    }
  }

  createMenuItems(facilityId:string){
    let menuItems:NbMenuItem[] = [
      {
        title:"Facility ["+facilityId+"]",
        group:true,
      },
      {
        "title":"Facility Overview",
        "link":'/admin/facilities/facility/'+facilityId+'/facility-overview/custom',
        icon:{icon:'facilities',pack:'custom-icons'},
        data:{
          event:ActionState.CUSTOM,
          type:"FacilityOverview",
          data:{
          "formData":{
                "formName":"EditOrder",
                "formLocation":"component://kwikstore/widget/FacilityForms.xml",
                "link":"/admin/facilities/facility/${facilityId}"
            },
          appContext:"facilities",
          }
        }
      },
      {
        title:"Facility Inventory",
        icon:{icon:'facility-inventory',pack:'custom-icons'},
        children:[
          {
            title:"Inventory Products",
            link:'/admin/facilities/facility/'+facilityId+'/inventory-products/relate',
            data:{
              event:ActionState.LIST,
              data:{
                formData:{
                  formName:"ListFacilityInventoryByProduct",
                  formLocation:"component://kwikstore/widget/FacilityForms.xml"
                },
                appContext:"facilities"
              }
            }
          },
          {
            title:"Inventory Items",
            link:'/admin/facilities/facility/'+facilityId+'/inventory-items/relate',
            data:{
              event:ActionState.LIST,
              data:{
                formData:{
                  formName:"ListFacilityInventoryItems",
                  formLocation:"component://kwikstore/widget/FacilityForms.xml"
                },
                appContext:"facilities"
              }
            }
          }
        ]
      },
      {
        title:"Locations",
        link:'/admin/facilities/facility/'+facilityId+'/facility-locations/master-detail',
        icon:{icon:'warehouse-locations',pack:'custom-icons'},
        data:{
          event:ActionState.MASTERDETAIL,
          type:"Locations",
          data:<RemoteFormData>{
            formData:{
              formName:"FindFacilityLocations",
              formLocation:"component://kwikstore/widget/FacilityForms.xml",
            },
            appContext:"facilities",
            parameters:{facilityId:this.facilityId}
          }
        }
      },
      {
        title:'Receive Inventory',
        icon:{icon:'receive-inventory',pack:'custom-icons'},
        children:[
          {
            title:"By Purchase Order",
            link:'/admin/facilities/facility/'+facilityId+'/receive-inventory-order/tasks-action-result',
            data:{
              event:ActionState.TASKSACTRSLT,
              type:'Receive Inventory',
              data:<RemoteFormData>{
                formData:{
                  formName:"FindFacilityLocations",
                  formLocation:"component://kwikstore/widget/FacilityForms.xml",
                },
                appContext:"facilities",
                parameters:{facilityId:this.facilityId}
              }
            }
          },
          {
            title:"By Product",
            link:'/admin/facilities/facility/'+facilityId+'/receive-inventory-product/tasks-action-result',
            data:{
              event:ActionState.TASKSACTRSLT,
              type:'Receive Inventory',
              data:<RemoteFormData>{
                formData:{
                  formName:"FindFacilityLocations",
                  formLocation:"component://kwikstore/widget/FacilityForms.xml",
                },
                appContext:"facilities",
                parameters:{facilityId:this.facilityId}
              }
            }
          }
        ]
        
      },
      {
        title:'Physical Inventory',
        icon:{icon:'physical-inventory',pack:'custom-icons'}
      },
      {
        title:'Inventory Transfers',
        icon:{icon:'inventory-transfer',pack:'custom-icons'}
      },
      {
        title:'Returns',
        icon:{icon:'warehouse-returns',pack:'custom-icons'}
      },
      {
        title:'Stock Moves',
        icon:{icon:'stock-moves',pack:'custom-icons'}
      },
      {
        title:'Picking & Packing',
        group:true
      },
      {
        title:'Picking',
        icon:{icon:'picking-bin',pack:'custom-icons'}
        //icon:'inbox-outline'
      },
      {
        title:'Pick Lists',
        icon:{icon:'pick-lists',pack:'custom-icons'}
      },
      {
        title:'Packing',
        icon:{icon:'packaging',pack:'custom-icons'}
      }
    ]
    setTimeout(() =>{
      this.contextMenuItems.emit(menuItems)
    },1)    
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
